import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import CoverityConfigListing from './CoverityConfigListing'
import CoverityCredentialsForm from './CoverityCredentialsForm'

export default function CoverityPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={CoverityCredentialsForm}
            PullConfigListingView={CoverityConfigListing}
        />
    )
}
